/**
 * Utilities for entry content links so they open outside the current view.
 * Used when the app is embedded in a WebView: prevents YouTube/external links
 * from loading inside the WebView and taking over the app.
 */

/**
 * Rewrites all <a href="..."> in entry HTML to target="_blank" and rel="noopener noreferrer"
 * so the host (e.g. WebView) can open them in system browser / external app.
 * @param {string} html - Raw entry HTML
 * @returns {string} HTML with links set to open in new window
 */
export function prepareEntryHtmlForWebView(html) {
  if (!html || typeof html !== 'string') return html;
  if (typeof document === 'undefined') return html;
  const div = document.createElement('div');
  div.innerHTML = html;
  div.querySelectorAll('a[href]').forEach((a) => {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });
  return div.innerHTML;
}

/**
 * Call this from the container's onClick when rendering entry HTML.
 * If the click was on a link, prevents default and opens the URL in a new window
 * so the WebView does not navigate in-place (e.g. to YouTube).
 * @param {React.MouseEvent} e - Click event on the entry content container
 */
export function handleEntryContentLinkClick(e) {
  const a = e.target.closest('a[href]');
  if (!a) return;
  const href = (a.getAttribute('href') || '').trim();
  if (!href || href.startsWith('#') || href.toLowerCase().startsWith('javascript:')) return;
  e.preventDefault();
  e.stopPropagation();
  window.open(href, '_blank', 'noopener,noreferrer');
}
